const LWC_AP23_URL = '/appeals/appeal23'

export default function ({ route }) {
  if (route.path === '/appeal23') {
    window.location.replace(LWC_AP23_URL)
  }
}
